module.exports = __webpack_public_path__ + "static/media/more-green.37450156.svg";